import React from "react";
import { Col } from "react-bootstrap";
import ClipLoader from "react-spinners/ClipLoader";
import { override } from "components/spinner/spinnerOverride";
import styles from "./AccountAnalysisPage.module.scss";
import genStyles from "styles/General.module.scss";

const AccountAnalysisPageLoading = ({
  accountName,
  analysisName,
}: {
  accountName: string;
  analysisName: string;
}) => {
  return (
    <Col style={{ width: "100%" }} className={genStyles["vertical-center"]}>
      <div className={genStyles["horizontal-center"]}>
        <ClipLoader color={"#52575a"} css={override} size={48} loading={true} />
        <p className={styles["loading__text"]}>Loading Report ...</p>
      </div>
    </Col>
  );
};

export default AccountAnalysisPageLoading;
